import React from 'react';

import {TableHeader, UserInformation} from "../../../../../../components";

import values from "../../../../../../values";
import convertGregorianToJalali from "../../../../../../utils/convertGregorianToJalali";

import './index.sass';

type Props = {
  driversList?: any;
};

const PayDeptstTable: React.FC<Props> = (props: Props) => {

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <tbody id="company-deposit-table-body-container">
      {props?.driversList?.map((driverList: any, index: number) => (
        <ThisBody driverList={driverList} index={index} />
      ))}
    </tbody>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default PayDeptstTable;

type thisProps = {driverList: any, index: number}

const ThisBody: React.FC<thisProps> = ({driverList, index}: thisProps): React.ReactElement => {

  const [isOpenDriverReports, setIsOpenDriverReports] = React.useState<boolean>(false);

  function handleOnClickDriverReport(): void {
    setIsOpenDriverReports(!isOpenDriverReports);
  }

  return (
    <>
      <tr key={`driver-${index}`} onClick={handleOnClickDriverReport} className={''}>
        <td className="pointer">
          <UserInformation
            avatar={driverList?.avatar}
            name={driverList?.firstName}
            isBlock={driverList?.approved?.isApprove}
            lastName={driverList?.lastName}
            phoneNumber={driverList?.phoneNumber}
            imgSize={'table-imgAvatar'}
          />
        </td>
        <td className="pointer">{driverList?.tagNumber}</td>
        <td className="pointer">{driverList?.countServices}</td>
        <td className="pointer">{driverList?.totalAmount}</td>
        <td className="pointer">{driverList?.totalShareCompany}</td>
        <td className="pointer">
          {isOpenDriverReports ? <i className={'fa-solid fa-chevron-up'} />
            : <i className={'fa-solid fa-chevron-down'} />
          }
        </td>
      </tr>
      <tr>
        <td colSpan={6} style={{padding: '0px'}}>
          {isOpenDriverReports && driverList?.reportsList && driverList?.reportsList.length > 0 && (
            <table>
              <TableHeader headers={values.tableHeaders.COMPANY_DIPOSIT_DRIVER_REPORT_LIST}/>
              <tbody>
              {driverList.reportsList.map((report: any, index: number) => (
                <>
                  <tr key={`driver-report-${index}`}>
                    <td className="pointer">{report?.countFactors}</td>
                    <td className="pointer">{report?.countServices}</td>
                    <td className="pointer">{report?.totalAmount}</td>
                    <td className="pointer">{report?.totalShareCompany}</td>
                  </tr>
                  <tr>
                    <td colSpan={4} style={{padding: '0px'}}>
                      <table>
                        <TableHeader headers={values.tableHeaders.COMPANY_DIPOSIT_DRIVER_REPORT_FACTOR_LIST}/>
                        <tbody>
                        {report?.factorList?.map((factor: any, index: number) => (
                          <tr key={`driver-report-${index}`}>
                            <td className="pointer">
                              <UserInformation
                                avatar={factor?.parent?.avatar}
                                name={factor?.parent?.firstName}
                                lastName={factor?.parent?.lastName}
                                phoneNumber={factor?.parent?.phoneNumber}
                                imgSize={'table-imgAvatar'}
                              />
                            </td>
                            <td className="pointer">
                              <UserInformation
                                avatar={factor?.student?.avatar}
                                name={factor?.student?.firstName}
                                lastName={factor?.student?.lastName}
                                imgSize={'table-imgAvatar'}
                              />
                            </td>
                            <td className="pointer">{factor?.price}</td>
                            <td className="pointer">{convertGregorianToJalali({date: factor?.paidDate})}</td>
                          </tr>
                        ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </>
              ))}
              </tbody>
            </table>
          )}
        </td>
      </tr>
    </>
  );
}
